import React from 'react';

class Story extends React.Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.state = {
      story: this.props.project.questionnaire.story,
    };
  }

  onChange(e) {
    this.props.updateProject(
      { questionnaire_attributes: { story: e.target.value } },
      formContext => {
        let data = formContext.state;
        data.questionnaire.story = e.target.value;
        formContext.setState(data);
      },
    );

    this.setState({ story: e.target.value });
  }

  getRowsCount() {
    let count = 3;
    if (this.state.story) {
      let match = this.state.story.match(/\n/g);
      if (match) {
        count = Math.max(count, match.length + 1);
      }
    }
    return count;
  }

  render() {
    return (
      <textarea
        className="form-control"
        rows={this.getRowsCount()}
        onChange={this.onChange}
        value={this.state.story}
        disabled={this.props.disabled}
        placeholder="leave us just a sentence or an essay. the more you can fill us in on what you want, how you imagine your room to feel, or just tell us what you don’t like – it’s all really helpful stuff! "
      />
    );
  }
}

export default Story;



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/components/UI/Story.js